/**
 * This store used to manage all vuex activity for login functionality like storing
 * managing login API call and sotre logged in user information in vuex store.
 * Getters also defined to get agent information
 */

const state = {
  accessToken: null,
  tokenType: null,
};

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const getters = {
  /**
   * Returned logged in agent data
   * @param {*} state vuex state
   */
  agentDetails(state) {
    return state.agentData;
  },
  getRefreshToken: function getRefreshToken() {
    return () => sessionStorage.getItem('refresh_token');
  },
  /**
   * Return auth credentials from session storage
   */
  getToken: function getToken() {
    return () => `${sessionStorage.getItem('tokenType')} ${sessionStorage.getItem('accessToken')}`;
  },
  /**
   * check if user is authenticated or not
   * @param {*} state vuex state
   */
  isAuthenticated(state) {
    return state.accessToken !== null;
  },
};

const mutations = {
  /**
   * Set login user data into vuex store. This data will be used
   * to send token back to api in each request
   * @param {*} state vuex state
   * @param {*} userData logged in user data
   */
  authAgent(state, userData) {
    state.accessToken = userData.access_token;
    state.tokenType = userData.token_type;
  },
  /**
   * Clear logged in user data from store on logout.
   * @param {*} state Vuex store
   */
  clearAuthData(state) {
    state.accessToken = null;
    state.sessionData = null;
    state.tokenType = null;
    state.searchResultParams = null;
  },
};

const actions = {
  /**
   * This action will clear logged in user data from session storage and
   * call clearAuthData mutation to clear data from vuex store
   */
  agentLogout({ commit }, authLogout) {
    commit('clearAuthData');
    sessionStorage.clear();
    localStorage.clear();
    // routes.replace('/');
    if (authLogout) {
      window.location.href = '/';
    }
  },
  /**
   * This fucntion set autiomatic logout expiration time for agent
   * @param {*} expirationTime logout expiration time
   */
  setLogoutTime({ commit }, expirationTime) {
    setTimeout(() => {
      commit('clearAuthData');
    }, expirationTime * 1000);
  },
  /**
   * This action calls login API and call mutation to set logged in user
   * information in vuex store
   * @param {*} authData user entered username and password
   */
  login({ commit }, response) {
    commit('authAgent', response.data);
  },
  /**
   * This method gets called from App.Vue component to check if user is still valid
   * and session storage still holds logged in user information.
   * It will reset vuex store with browser sessionStorage data.
   */
  autoLoginCall({ commit }) {
    const sToken = sessionStorage.getItem('accessToken');
    if (!sToken) {
      return;
    }
    const sTokenType = sessionStorage.getItem('tokenType');
    commit('authAgent',
      {
        access_token: sToken,
        token_type: sTokenType,
      });
  },
};

/**
 * export module to main store.js
 */
export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/login.js